import * as React from "react";
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import {useSelector} from "react-redux";
import {State} from "../reducer";
import BlockUi from "@availity/block-ui";
import {getRuns} from "../action/ouvrageAction";
import {useLocation} from "react-router-dom";
import {readQueryParams, searchParam} from "../epic/searchEpic";
import {Autocomplete} from "@mui/material";
import TextField from "@mui/material/TextField";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import {useEffect} from "react";
import { useAppDispatch } from "../store";
import { useUpdateQueryParam } from "../hook";
import { CircularProgress } from "@mui/material";



export const RunFilter = () => {

    const ouvrageLoading = useSelector(({ouvrages}: State) => ouvrages.ouvrageLoading);
    const dispatch = useAppDispatch();
    const searchLocation = useLocation().search;
    const queryFilters = readQueryParams(searchParam, searchLocation);
    const handleUpdateQueryParam = useUpdateQueryParam();

    const handleChangerun = (event: React.ChangeEvent<{}>, values: number | null | number[]) => {
        handleUpdateQueryParam(`run`, values)
    };

    useEffect(() => {
        dispatch(getRuns(true))
    }, [dispatch])

    const runs = useSelector(({ouvrages}: State) => ouvrages.runs);


    const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
    const checkedIcon = <CheckBoxIcon fontSize="small"/>;

    return (
        <FormControl component="fieldset" sx={{margin: '2px 0'}} size={"small"}>
            <FormLabel component="legend">Run</FormLabel>
            <BlockUi loader={<CircularProgress size="1rem" />} tag="div" blocking={ouvrageLoading}>
                <FormGroup>
                    <div className="marque-editorial run">
                        <Autocomplete
                            id="checkboxes-run"
                            multiple
                            size={"small"}
                            value={queryFilters?.run}
                            options={runs}
                            disableCloseOnSelect
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option}
                                </li>
                            )}
                            onChange={(run, val) => handleChangerun(run, val)}
                            renderInput={(params) => (
                                <TextField {...params} variant="outlined"/>
                            )}
                        />
                    </div>
                </FormGroup>
            </BlockUi>
        </FormControl>
    )
};
